import CategoryNameRemapping from './CategoryNameRemapping.json';

export const remapCategoryName = (categoryName: string): string => {
  const remappedName =
    CategoryNameRemapping[categoryName as keyof typeof CategoryNameRemapping] ||
    categoryName;
  return remappedName;
};
